import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import { retrySolarSetupRead } from "./solar-read-retry"
import type { SolarProposalVppProgramsDto } from "../dto/solar-proposal-pricing-steps.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/** Eligible VPP programs with their estimates, and removals to acknowledge. */
export default function useSolarProposalVppPrograms(
  proposalId: string | undefined,
): UseQueryResult<SolarProposalVppProgramsDto, unknown> {
  return useQuery({
    queryKey: queryKeys.solarProposal.vppPrograms(proposalId ?? ``),
    queryFn: () => solarProposalService.getVppPrograms(proposalId ?? ``),
    enabled: Boolean(proposalId),
    retry: retrySolarSetupRead,
  })
}
